import { render } from "./InvitationResponse.vue?vue&type=template&id=a88e7784&scoped=true"
import script from "./InvitationResponse.vue?vue&type=script&lang=js"
export * from "./InvitationResponse.vue?vue&type=script&lang=js"

import "./InvitationResponse.vue?vue&type=style&index=0&id=a88e7784&scoped=true&lang=css"

import exportComponent from "/Users/ergishoxha/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a88e7784"]])

export default __exports__